import { render } from "./TotalCallsCard.vue?vue&type=template&id=af5247d8"
import script from "./TotalCallsCard.vue?vue&type=script&lang=js"
export * from "./TotalCallsCard.vue?vue&type=script&lang=js"
script.render = render

export default script